/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';

import BaseLink from '@salesforce/retail-react-app/app/components/link';
import {Link as ChakraLink} from '@salesforce/retail-react-app/app/components/shared/ui/Link';

import {urlHelper} from '@amblique/base/app/helpers/url-helper';

/**
 * @param {{href: string, parse: boolean}} args
 *
 * @returns {React.ReactElement}
 */
const Link = React.forwardRef(({href, to, useNavLink, parse = false, ...rest}, ref) => {
  if (parse && href) {
    const {appUrl} = urlHelper.parseStorefrontUrl(href);

    if (appUrl) {
      to = appUrl;
    }
  }

  if ((to || useNavLink)) {
    return <BaseLink ref={ref} to={to || href} useNavLink={useNavLink} {...rest} />;
  } else {
    return <ChakraLink ref={ref} href={href} {...rest} />;
  }
});

Link.displayName = 'Link';
Link.propTypes = {
  href: PropTypes.string,
  to: PropTypes.string,
  useNavLink: PropTypes.bool,
  parse: PropTypes.bool,
};

export default React.memo(Link);
